var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA1Socket2P(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 38a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM69 38a31 31 0 11-62 0 31 31 0 0162 0zm-3.76 0A27.24 27.24 0 1038 65.24 27.27 27.27 0 0065.24 38zm-41-4.5a4.5 4.5 0 10.01 0h-.01z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A1_Socket_2P.5411427f.svg";
export { SvgA1Socket2P as ReactComponent };